import API from '../api/PriceApi'
import * as EndPoints from '../api/EndPoints'
import { message } from 'antd'
import { RESPONSE_MESSAGE } from '../utils/constants'

const GET_PRICES_REQUEST = 'priceManagement/GET_PRICES_REQUEST'
const GET_PRICES_SUCCESS = 'priceManagement/GET_PRICES_SUCCESS'
const GET_PRICES_FAILURE = 'priceManagement/GET_PRICES_FAILURE'

const CREATE_PRICE_REQUEST = 'priceManagement/CREATE_PRICE_REQUEST'
const CREATE_PRICE_SUCCESS = 'priceManagement/CREATE_PRICE_SUCCESS'
const CREATE_PRICE_FAILURE = 'priceManagement/CREATE_PRICE_FAILURE'

const UPDATE_PRICE_REQUEST = 'priceManagement/UPDATE_PRICE_REQUEST'
const UPDATE_PRICE_SUCCESS = 'priceManagement/UPDATE_PRICE_SUCCESS'
const UPDATE_PRICE_FAILURE = 'priceManagement/UPDATE_PRICE_FAILURE'

const DELETE_PRICE_REQUEST = 'priceManagement/DELETE_PRICE_REQUEST'
const DELETE_PRICE_SUCCESS = 'priceManagement/DELETE_PRICE_SUCCESS'
const DELETE_PRICE_FAILURE = 'priceManagement/DELETE_PRICE_FAILURE'

const initialState = {
  isLoading: true,
  error: {},
  prices: []
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_PRICES_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case GET_PRICES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        prices: Array.isArray(action.payload) ? action.payload : []
      }
    case GET_PRICES_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case CREATE_PRICE_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case CREATE_PRICE_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case CREATE_PRICE_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case UPDATE_PRICE_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case UPDATE_PRICE_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case UPDATE_PRICE_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case DELETE_PRICE_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case DELETE_PRICE_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case DELETE_PRICE_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    default:
      return state
  }
}

export const getPrices = () => {
  return async (dispatch) => {
    try {
      dispatch({ type: GET_PRICES_REQUEST })
      const response = await API.get(EndPoints.PRICE)
      dispatch({
        type: GET_PRICES_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: GET_PRICES_FAILURE,
        error: err
      })
    }
  }
}

export const createPrice = (data) => {
  return async (dispatch) => {
    try {
      dispatch({ type: CREATE_PRICE_REQUEST })
      await API.post(EndPoints.PRICE, data)
      dispatch({ type: CREATE_PRICE_SUCCESS })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: CREATE_PRICE_FAILURE,
        error: err
      })
    }
  }
}

export const updatePrice = (data) => {
  return async (dispatch) => {
    try {
      dispatch({ type: UPDATE_PRICE_REQUEST })
      await API.put(EndPoints.PRICE + `/${data.id}`, data)
      dispatch({ type: UPDATE_PRICE_SUCCESS })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: UPDATE_PRICE_FAILURE,
        error: err
      })
    }
  }
}

export const deletePrice = (id) => {
  return async (dispatch) => {
    try {
      dispatch({ type: DELETE_PRICE_REQUEST })
      await API.delete(EndPoints.PRICE + `/${id}`)
      dispatch({ type: DELETE_PRICE_SUCCESS })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: DELETE_PRICE_FAILURE,
        error: err
      })
    }
  }
}
